import { Weekday } from "planning-portal-library/src/lib/core/domain/models/week-days";
import { WeekdayWebEntity } from "./weekday-web-entity";
import { Mapper } from "planning-portal-library/src/lib/core/base";

export class WeekdayWebRepositoryMapper extends Mapper<WeekdayWebEntity, Weekday> {
    mapFrom(param: WeekdayWebEntity): Weekday {
      return {
        id: param.id,
        name: param.name,
      };
    }
  
    mapTo(param: Weekday): WeekdayWebEntity {
      return {
        id: param.id,
        name: param.name,
      };
    }
  
  }